import { EPaymentType } from "../Enums/EPaymentType.enum";
import { BaseModel } from "./base/base.model";

export class SolicitudBolsaVacaciones extends BaseModel {
  Dias: number;
  CodigoTrabajador: string;
  CodigoEmpresa: string;
  CodigoImputacion: string;
  Ejercicio: number;
  A3LVariableConceptId: string;
  A3LExtraPaymentId: string
  Observaciones: string;
  Importe: number;
  FechaSolicitud: Date;
  Destino: EPaymentType;
}
